import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { Subject } from "rxjs";
import { distinctUntilChanged, takeUntil } from "rxjs/operators";

@Component({
    selector: "clare-button-toggle",
    templateUrl: "./clare-button-toggle.component.html",
    styles: [
        `
            .label {
                text-align: left;
            }

            .toggle {
                text-align: right;
            }
        `,
    ],
})
export class ClareButtonToggleComponent implements OnInit, OnDestroy {
    @Input() metaData: any;
    @Input() isLoading: boolean;
    @Input() theForm: FormGroup;
    @Input() enableRetry: boolean;
    @Output() getValueEmitter = new EventEmitter<void>();

    public options = [];

    private unsubscribe$ = new Subject<void>();

    ngOnInit() {
        this.options = this.sortOptions(this.metaData?.enum || {});

        const formControl = this.theForm?.controls[this.metaData?.inputName];
        formControl?.setValue(formControl.value + "", { emitEvent: false });

        formControl?.valueChanges.pipe(distinctUntilChanged(), takeUntil(this.unsubscribe$)).subscribe(value => {
            if (value === null) {
                formControl.disable({ emitEvent: false });
            } else {
                formControl.enable({ emitEvent: false });
            }
        });
    }

    sortOptions(metaDataOptions: Record<string, string | boolean | number>) {
        const options = [];

        for (const option in metaDataOptions) {
            if (metaDataOptions.hasOwnProperty(option)) {
                options.push({ key: option, value: metaDataOptions[option] });
            }
        }

        options.sort(a => (a.value === true || a.value === 1 || a.value === "true" ? 1 : -1));

        return options;
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next(null);
        this.unsubscribe$.complete();
    }
}
